module.exports = __webpack_public_path__ + "assets/img/btn-view-118adcee.png";